import { getString } from "../../common/common";

export const SORT = 'Sorted_in_Descending_Order_by:Journey_Date';
export const JOURNEY_DATE = 'Journey_Date';
export const BOOKING_DATE = 'Booking_Date';
export const PNR = 'PNR';
export const TRIP_CODE = 'TripCode';
export const BUS_TYPE = 'BusType';
export const BOOKED_ON = 'Booked_on';
export const CLOSE_BOOKING = 'Close_Booking';
export const VIEW_BOOKING = 'View_Booking';
export const VIEW_ON_MAP = 'View_on_Map';
export const CLOSE_MODIFY_BOOKING = 'Close_Modify_Booking';
export const MODIFY_BOOKING = 'Modify_Booking';
export const CLOSE_CANCEL_BOOKING = 'Close_Cancel_Booking';
export const CANCEL_BOOKING = 'Cancel_Booking';
export const BOOK_AGAIN = 'Book_Again';
export const REFUND_DETAILS = 'Refund_Details';
export const UPCOMING = 'Upcoming';
export const COMPLETED = 'Completed';
export const CANCELLED = 'Cancelled';
export const WL_TRANS = 'WL_Transactions';
export const FAVOURITE = 'Favourite';

export const translations = {
    en: {
        [SORT]: "Sorted in Descending Order by:Journey Date",
        [JOURNEY_DATE]: "Journey Date",
        [BOOKING_DATE]: "Booking Date",
        [PNR]: "PNR:",
        [TRIP_CODE]: "TripCode:",
        [BUS_TYPE]: 'BusType',
        [BOOKED_ON]: 'Booked on',
        [CLOSE_BOOKING]: 'Close Booking',
        [VIEW_BOOKING]: 'View Booking',
        [VIEW_ON_MAP]: 'View on Map',
        [CLOSE_MODIFY_BOOKING]: 'Close Modify Booking',
        [MODIFY_BOOKING]: 'Modify Booking',
        [CLOSE_CANCEL_BOOKING]: 'Close Cancel Booking',
        [CANCEL_BOOKING]: 'Cancel Booking',
        [BOOK_AGAIN]: 'Book Again',
        [REFUND_DETAILS]: 'Refund Details',
        [UPCOMING]: 'Upcoming',
        [COMPLETED]: 'Completed',
        [CANCELLED]: 'Cancelled',
        [WL_TRANS]: 'WL Transactions',
        [FAVOURITE]: 'Favourite',
    },
    kn: {
        [SORT]: "ಇಳಿಕೆಯ  ಕ್ರಮದಲ್ಲಿ ವಿಂಗಡಿಸಲಾಗಿದೆ: ಪ್ರಯಾಣದ ದಿನಾಂಕ",
        [JOURNEY_DATE]: "ಪ್ರಯಾಣದ ದಿನಾಂಕ",
        [BOOKING_DATE]: "ಬುಕಿಂಗ್ ದಿನಾಂಕ",
        [PNR]: "PNR:", //todo
        [TRIP_CODE]: "ಟ್ರಿಪ್ ಕೋಡ್:",
        [BUS_TYPE]: 'ಬಸ್ ವರ್ಗ',
        [BOOKED_ON]: 'ಇಂದು ಬುಕ್ ಮಾಡಲಾಗಿದೆ',
        [CLOSE_BOOKING]: 'ಬುಕಿಂಗ್ ಅನ್ನು ಮುಚ್ಚಿ',
        [VIEW_BOOKING]: 'ಬುಕಿಂಗ್ ವೀಕ್ಷಿಸಿ',
        [VIEW_ON_MAP]: 'ಮಾಪ್ ನಲ್ಲಿ ನೋಡಿ',
        [CLOSE_MODIFY_BOOKING]: 'ಬುಕಿಂಗ್ ಮಾರ್ಪಡಿಸಿಯನ್ನು ಮುಚ್ಚಿ',
        [MODIFY_BOOKING]: 'ಬುಕಿಂಗ್ ಅನ್ನು ಮಾರ್ಪಡಿಸಿ',
        [CLOSE_CANCEL_BOOKING]: 'ಬುಕಿಂಗ್ ರದ್ದುಮಾಡಿಯನ್ನು ಮುಚ್ಚಿ',
        [CANCEL_BOOKING]: 'ಬುಕಿಂಗ್ ರದ್ದುಮಾಡಿ',
        [BOOK_AGAIN]: 'ಮತ್ತೆ ಬುಕ್ ಮಾಡಿ',
        [REFUND_DETAILS]: 'ರೀಫಾನ್ಡ್ ವಿವರಗಳು',
        [UPCOMING]: 'ಮುಂಬರುವ',
        [COMPLETED]: 'ಪೂರ್ಣಗೊಂಡಿದೆ',
        [CANCELLED]: 'ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ',
        [WL_TRANS]: 'WL ಟ್ರಾನ್ಸಾಕ್ಷನ್ ',
        [FAVOURITE]: 'Favourite',
    },
};

export const t = (key = "") => {
    return getString(key, translations)
}